import React from 'react';

function ErrorPage() {
    return (
      <div className="App">
        <h2>Sorry, we could not find the page you asked for</h2>
      </div>
    );
  }
export default ErrorPage